import { PortModelAlignment } from '@projectstorm/react-diagrams';
import NodeTypes from '../../NodeTypes';
import DefaultNodeModel, { DefaultNodeModelOptions } from '../defaultNode/DefaultNodeModel';
import { PortModel } from '../../ports/PortModel';

export interface StartNodeModelOptions extends DefaultNodeModelOptions {
}

export class StartNodeModelData {
}

export default class StartNodeModel extends DefaultNodeModel {
	data: StartNodeModelData = new StartNodeModelData();

	constructor(options: StartNodeModelOptions = {}) {
	  super({
	    ...options,
	    type: NodeTypes.startNode,
	  });
	  // setup an in and out port
	  this.addPort(
	    new PortModel({
	      in: true,
	      name: 'in',
	      alignment: PortModelAlignment.BOTTOM,
	    }),
	  );
	}

	serialize() {
	  return {
	    ...super.serialize(),
	  };
	}

	deserialize(event:any): void {
	  super.deserialize(event);
	}
}
